module.exports = __webpack_public_path__ + "img/dischargeMgt.677cd8d2.svg";